Ext.ns('mx.Util');

mx.Util.Connection = {
    /**
     * Делает submit виртуальной формы во фрейме. Может пригодится, когда нужно из
     * JS сделать запрос, в результате которого пользователю будет предложено
     * скачать файл.
     *
     * @param conf Массив параметров. Должен содержать:
     *  - method    POST или GET
     *  - URL       URL запроса
     *  - params    массив параметров запроса
     *  - callback  функция обратного вызова
     *  - scope     объект, в контексте которого будет вызван callback
     */
    submitRequest: function(conf) {
        var config = {
            method: 'POST',
            callback: null,
            scope: null,
        };
        config = Ext.apply(config, conf || {});

        var frame = this.createIFrame();
        var form = this.createForm(frame, config);
        var loadHandler = this.getLoadHandlerForIFrame(frame, config.scope, config.callback);
        Ext.EventManager.on(frame, 'load', loadHandler, this);
        form.submit();
    },

    //private
    createIFrame: function() {
        var id = Ext.id();
        var frame = document.createElement('iframe');
        frame.id = id;
        frame.name = id;
        frame.className = 'x-hidden';
        if (Ext.isIE) {
            frame.src = Ext.SSL_SECURE_URL;
        }
        document.body.appendChild(frame);
        if (Ext.isIE) {
            document.frames[id].name = id;
        }
        return frame;
    },

    //private
    createForm: function(frame, conf) {
        var form = document.createElement('form');
        form.method = conf.method;
        if (conf.url) {
            form.action = conf.url;
        }
        if (conf.params) {
            var params = conf.params;
            for (var k in params) {
                if (params.hasOwnProperty(k)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = k;
                    input.value = params[k];
                    form.appendChild(input);
                }
            }
        }

        frame.appendChild(form);
        form.target = frame.id;
        return form;
    },

    //private
    getLoadHandlerForIFrame: function(frame, callbackScope, callback) {
        var handler = function() {
            var r = {
                // bogus response object
                responseText: '',
                responseXML: null,
            };

            try {
                //
                var doc;
                if (Ext.isIE) {
                    doc = frame.contentWindow.document;
                } else {
                    doc = frame.contentDocument || window.frames[id].document;
                }
                if (doc && doc.body) {
                    r.responseText = doc.body.innerHTML;
                }
                if (doc && doc.XMLDocument) {
                    r.responseXML = doc.XMLDocument;
                } else {
                    r.responseXML = doc;
                }
            } catch (e) {
                // ignore
            }

            Ext.EventManager.removeListener(frame, 'load', handler, this);
            if (callback && callbackScope) {
                Ext.callback(callback, callbackScope, [r]);
            }
            setTimeout(function() {
                Ext.removeNode(frame);
            }, 100);
        };

        return handler;
    },
};
